import { defineMessages } from 'react-intl';

export const scope = 'app.components.PartnerDetailsModal';

export default defineMessages({
  expiresOn: {
    id: `${scope}.expiresOn`,
    defaultMessage: 'Background check expires on {date}',
    description:
      'Names the first day a passing background check can no longer be reused, above the details of the package it was run under',
  },
  expiredOn: {
    id: `${scope}.expiredOn`,
    defaultMessage: 'Background check expired on {date} — new check required',
    description:
      'Tells a recruiter a background check is no longer valid and a new one has to be run, with the day it stopped being valid',
  },
});
